export default {
    data() {
        return {
            availableTabs: [],
        }
    },
    methods: {
        canViewTab(tab) {
            if (tab === 'administrator') {
                return this.userRole === 'administrator'
            }
            if (tab === 'manager') {
                return this.isManager
            }
            return true
        },
        async parseAvailableTabs() {
            this.availableTabs = this.tabs
                .filter(tab => this.canViewTab(tab.id))
                .map(t => {
                    t.active = false
                    return t
                })

            return
        },
    },
    computed: {
        userRole() {
            const roleName = this.currentUser.role.name
            if (
                roleName === 'administrator' ||
                roleName === 'god' ||
                roleName === 'local_administrator' ||
                this.currentUser.is_values_master
            ) {
                return 'administrator'
            }
            return this.isManager ? 'manager' : 'user'
        },

        isManager() {
            return this.currentUser.subordinates.length > 0
        },
    },
}
